import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "./productsSlice";
import dealersReducer from "./dealersSlice";
import cartReducer, { attachCartPersistence } from "./cartSlice";

export const store = configureStore({
  reducer: {
    products: productsReducer,
    dealers: dealersReducer,
    cart: cartReducer,
  },
});

attachCartPersistence(store);
